<label [for]="name()" class="flex gap-2">
  <div class="relative grid place-items-center">
    <input
      class="border-theme-secondary-gray peer checked:border-theme-primary-blue checked:bg-theme-primary-blue col-start-1 row-start-1 aspect-square w-5 cursor-pointer appearance-none rounded-sm border-2"
      type="checkbox"
      [checked]="checked()"
      [id]="name()"
      [disabled]="disabled()"
      [readonly]="readonly()"
      (click)="toggle()" />

    <div
      class="pointer-events-none absolute top-0 right-0 bottom-0 left-0 z-10 hidden items-center justify-center peer-checked:flex">
      <shared-core-material-icon class="h-full w-full scale-75 text-white" [name]="'check'" />
    </div>
  </div>

  <div class="text-nowrap">
    @if (label()) {
      @if (!labelTemplate()) {
        <button (click)="toggle()">{{ label() }}</button>
      } @else {
        <ng-container
          [ngTemplateOutlet]="labelTemplate()"
          [ngTemplateOutletContext]="{ $implicit: label() }" />
      }
    }
  </div>
</label>
